import { BaseCriteriaModel } from './base-criteria.model';
import { Optional } from 'typescript-optional';

export class CmsActivityHighlightQueryCriteriaClass extends BaseCriteriaModel {
  date_from?: Optional<string> = Optional.empty();
  date_to?: Optional<string> = Optional.empty();
  activity_guid?: Optional<string> = Optional.empty();
  is_recurring?: Optional<string> = Optional.empty();
}

export class CmsActivityHighlightCriteriaModelQuery {
  query = '';

  constructor(criteria: CmsActivityHighlightQueryCriteriaClass) {

    if (!criteria) {
      return;
    }

    this.query += criteria.date_from.filter(x => x !== '').map(x => '&date_from=' + x).orElse('');
    this.query += criteria.date_to.filter(x => x !== '').map(x => '&date_to=' + x).orElse('');
    this.query += criteria.activity_guid.filter(x => x !== '').map(x => '&activity_guid=' + x).orElse('');
    this.query += criteria.is_recurring.filter(x => x !== '').map(x => '&is_recurring=' + x).orElse('');

    this.query += '&status=' + criteria.status;
    this.query += '&orderBy=' + criteria.orderBy;
    this.query += '&order=' + criteria.order;
    this.query += '&offset=' + criteria.offset + '&limit=' + criteria.limit;

    if (criteria.calcTotalRecords) {
      this.query += '&calcTotalRecords=' + criteria.calcTotalRecords;
    }
  }
}
